module.exports = __webpack_public_path__ + "img/logo-new.c2d763bc.png";